export default "__VITE_ASSET__ChV2z3wZ__"